import * as React from "react";
import AlertModalForm from "../../Forms/buypermits/AlertModalForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const AlertModal=(props)=>{ 
   const {isOpenAlertModal,CloseAlertModal,data} = props;
   
    return(
        <>
            <BaseModal
                title="Alert"
                align="center"
                open={isOpenAlertModal}
                onClose={CloseAlertModal}
                with={500}                
            >
                <BaseModalContent>
                   <AlertModalForm 
                      CloseAlertModal={CloseAlertModal}
                      data={data}
                   />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default AlertModal;